export const datosMotoForm = {
    isValid: false,
    values: {
        numSerie: "",
        numMotor: ""
    },
    touched: {
        numSerie: "",
        numMotor: ""
    },
    errors: {}
};

export const datosMotoConstraints = {
    numSerie: {
        presence: {
            allowEmpty: false,
            message: '^El usuario es requerida.'
        }
    },
    numMotor: {
        presence: {
            allowEmpty: false,
            message: '^La contraseña es requerida.'
        }
    },
};